/**
 * @generated SignedSource<<3d48f8b0bacb79c95b9fb912493df795>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useMyIdFragment$data = {
  readonly id: number | null | undefined;
  readonly " $fragmentType": "useMyIdFragment";
};
export type useMyIdFragment$key = {
  readonly " $data"?: useMyIdFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useMyIdFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useMyIdFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "162ee98c1fc5608caed073c6b27a5749";

export default node;
